class Helper {
  constructor() {
    this._initializeNaturalExtensions();
  }

  isJSON(obj) {
    try {
      JSON.parse(obj);
      return true;
    } catch (error) {
      return false;
    }
  }
  _initializeNaturalExtensions() {
    if (!String.prototype.format) {
      String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
          return typeof args[number] !== "undefined" ? args[number] : match;
        });
      };
    }
  }
}

export default Helper;
